const subRequestTypeOptions = [
  {
    id: 1,
    title: 'Des informations sur un rendez-vous déjà pris sur le site ad.fr ?',
  },
  {
    id: 2,
    title:
      "De l'aide ou un conseil pour prendre un rendez-vous sur le site ad.fr ?",
  },
  { id: 3, title: 'Des informations sur un réparateur du réseau AD ?' },
  { id: 4, title: 'Autres' },
] as const;

export default subRequestTypeOptions;
